import React from "react";
import "./table1.css";
import { useSelector } from "react-redux";
import moment from "moment";
import { getRateTrend, getRateChangePercent } from "./CommonFunction";

const TableData2 = () => {
  const data = useSelector((state) => state.MetalDataReducer.data);
  console.log(data);
  return (
    <div>
     
      <span className="Updatedtime">
        Updated On: {moment.utc(data[0]?.updated).local().format("YYYY-MM-DD hh:mm:ss A")}
      </span>

    
      <table className="table22"  >
        {/* <caption>Statement Summary</caption> */}
        <thead>
          <tr>
            <th scope="col">Metal Type</th>
            <th scope="col">Sale Rate per gm</th>
            <th scope="col">Purchase Rate per gm</th>
            {/* <th scope="col">Period</th> */}
          </tr>
        </thead>
        <tbody>
          {data.map((item) => {
            const saleTrend = getRateTrend(item.sale_amount, item.sale_old_rate);
            const salePercent = getRateChangePercent(item.sale_amount, item.sale_old_rate);
            return (
              <tr>
                <td data-label="Metal Type">
                  {/* // product name is silver 0 then silver article else if silver 100 then silver bar else as it is */}
                  {item.product_name === "Silver 0" ? (
                    "Silver Article"
                  ) : item.product_name === "silver 100" ? (
                    "Silver Bar"
                  ) : (
                    <>{ item.product_name}T</>
                  )}
                </td>
                <td data-label="Sale Rate per gm">

                    { Number(item.sale_amount).toFixed(2)}
                    {saleTrend === "up" && <span style={{ color: "red", fontSize: "inherit", marginLeft: "16px", verticalAlign: "middle" }}>▲ {salePercent}%</span>}
                    {saleTrend === "down" && <span style={{ color: "green", fontSize: "inherit", marginLeft: "16px", verticalAlign: "middle" }}>▼ {salePercent}%</span>}
                </td>

                 {/* {item.sale_amount % 1 === 0
                    ? `${item.sale_amount}.0`
                    : item.sale_amount} */}

                {/* <td data-label="Sale Rate per gm">{Math.round(item.sale_amount)}</td> */}

                <td data-label="Purchase Rate per gm">
                  {Number(item.purchase_amount).toFixed(2)}
                  {/* {item.purchase_amount} */}
                  {/* {item.purchase_amount % 1 === 0
                    ? `${item.purchase_amount}.0`
                    : item.purchase_amount} */}
                </td>
                {/* <td data-label="Period">03/01/2016 - 03/31/2016</td> */}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TableData2;
